import { z } from 'zod'

export const WORK_TASK_TRACKER_PROJECT_CONTRACT_VERSION = '1.0.0' as const
export const workTaskTrackerProjectResponseSchema = z.unknown()
export type WorkTaskTrackerProjectResponse = z.infer<typeof workTaskTrackerProjectResponseSchema>
